"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allSettingsById = exports.allSettings = exports.soilSettings = exports.weatherSettings = void 0;
const _arrayOfValueTypes_1 = require("./_arrayOfValueTypes");
exports.weatherSettings = _arrayOfValueTypes_1.VALUES_TIMESERIES_TYPES_SETTINGS.filter((v) => v.sectionId === 'weather' && v.valueTypeGroupId !== 'leaf_wetness');
exports.soilSettings = _arrayOfValueTypes_1.VALUES_TIMESERIES_TYPES_SETTINGS.filter((v) => v.valueTypeGroupId === 'soil');
exports.allSettings = _arrayOfValueTypes_1.VALUES_TIMESERIES_TYPES_SETTINGS;
exports.allSettingsById = Object.fromEntries(_arrayOfValueTypes_1.VALUES_TIMESERIES_TYPES_SETTINGS.map((setting) => [setting.id, setting]));
//# sourceMappingURL=_settings.js.map